/* eslint-disable */

import store from '../store';
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

const axios = require("axios");

/**
 * @returns {object}
 */
export async function recordToken(token, utilisateur, api, dateCreation, dateExpiration) {
    if (!utilisateur) {
        utilisateur = store.getters.getSitimmoUser.login
    }
    if (!api) {
        api = "META"
    }
    let params = {
        token: token,
        utilisateur: utilisateur,
        api: api,
        date_creation: dateCreation,
        date_expiration: dateExpiration
    }
    return HTTP_HYPER_ESPACE_BACKEND
        .post('/create_token_utilisateur_api', params)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return error;
        });
}

export async function getTokenUtilisateur(api) {
    const params = { params: {utilisateur: store.getters.getSitimmoUser.login, api: api} }
    const tokenUtilisateur = HTTP_HYPER_ESPACE_BACKEND.get('/token_utilisateur_api', params).then(response => {
        return response.data._embedded.token_utilisateur_api[0]
    }).catch(error => {
        console.log('token_utilisateur_api: ' + error)
    })
    return tokenUtilisateur
}

export async function issetTokenUtilisateur() {
    const params = { params: {utilisateur: store.getters.getSitimmoUser.login, api: "META"} }
    const issetTokenUtilisateur = HTTP_HYPER_ESPACE_BACKEND.get('/isset_token_utilisateur_api', params).then(response => {
        return response.data
    }).catch(error => {
        console.log('issetTokenUtilisateur: ' + error)
    })
    return issetTokenUtilisateur
}

/**
 * @param userId
 * @param pageId
 * @returns {Promise<unknown>}
 */
export function recordDiffusionsMeta (userIdFacebook, userIdInstagram, pageId) {
    const params = { userIdFacebook: userIdFacebook, userIdInstagram: userIdInstagram, pageId: pageId }
    return HTTP_HYPER_ESPACE_BACKEND.post('/diffusion_annonceur_meta', params).then(response => {})
    .catch(error => {
        console.log(error)
    })
}

/**
 * @returns {Promise<T | void>}
 */
export function disconnectFacebook () {
    const params = { utilisateur: store.getters.getSitimmoUser.login, api: "META" }
    return HTTP_HYPER_ESPACE_BACKEND.post('/disconnect_facebook', params).then(response => {})
        .catch(error => {
            console.log(error)
        })
}

export function recordDiffusionsGoogle (location) {
    const params = { location: location }
    return HTTP_HYPER_ESPACE_BACKEND.post('/diffusion_annonceur_google', params).then(response => {})
        .catch(error => {
            console.log(error)
        })
}

export function recordDiffusionsLinkedin (organizationId) {
    const params = { organization: organizationId }
    return HTTP_HYPER_ESPACE_BACKEND.post('/diffusion_annonceur_linkedin', params).then(response => {})
        .catch(error => {
            console.log(error)
        })
}

export function disconnectLinkedin () {
    return HTTP_HYPER_ESPACE_BACKEND.post('/linkedin/remove').then(response => {})
        .catch(error => {
            console.log(error)
            throw error
        })
}
